import { on } from "delegated-events";
import { StoreManager } from "../../assets/js/helpers/store";

export class FlexList {
  
    cssClass = "c-flexlist";
    cssClassItem = `${this.cssClass}__item`;
    listElementClass = `${this.cssClass}__list`;
    showMoreElementSelector = `${this.cssClassItem}--show-more`;
    hiddenCssClass = `--hidden`;
    config = {};
    currentConfig = {};
    listElement = null;

    constructor(el = null) {
        this.el = el;
        this.listElement = this.el.querySelector(`.${this.listElementClass}`);
        this.init();
    }

    loadConfig(){
        if( this.el.dataset.config !== undefined ){
            this.config = JSON.parse(this.el.dataset.config);
        }else{
            return false;
        }
    }

    manageList(){

        this.el.querySelectorAll(`.${this.cssClassItem}`).forEach( (element, index) => {
            if( index >= this.currentConfig.visibleElements ){
                element.classList.add(`${this.hiddenCssClass}`);
            }else if( element.classList.contains(`${this.hiddenCssClass}`) && !element.classList.contains(`${this.showMoreElementSelector}`) ){
                element.classList.remove(this.hiddenCssClass);
            }
        });
        if( this.el.querySelectorAll(`.${this.cssClassItem}.${this.hiddenCssClass}:not(.${this.showMoreElementSelector})`).length > 0 ){
            this.el.querySelector(`.${this.showMoreElementSelector}`).classList.remove(this.hiddenCssClass);
        }else{
            this.el.querySelector(`.${this.showMoreElementSelector}`).classList.add(this.hiddenCssClass);
        }
    }

    processConfig(){

        this.loadConfig();
        var breakpoints = [];

        if( this.config.breakpoints !== undefined ){
            breakpoints = Object.keys(this.config.breakpoints);
            breakpoints.forEach( (bp) => {
                if( window.matchMedia(`(min-width: ${bp}px)`).matches == true ){
                    this.currentConfig = this.config.breakpoints[bp];
                }
            });
        }else{
            this.currentConfig = this.config;
        }
        this.manageList();
    }

    manageShowMoreButton() {
        const showMoreBtn = this.el.querySelector(`.${this.showMoreElementSelector}`);
        if (!showMoreBtn) return;

        showMoreBtn.addEventListener('click', () => {
            this.currentConfig.visibleElements = this.el.querySelectorAll(`.${this.cssClassItem}:not(.${this.showMoreElementSelector})`).length;
            this.manageList();
        });
    }

    boot(){
        this.processConfig();
        //If not safari make it awesome
        //window.addEventListener("resize", () => { this.processConfig(); } );
        this.manageShowMoreButton();
    }

    init(){
        this.boot();
    }

}